<template >
  <div style="margin-top:0px; margin-left:0px; margin-right:0px">
    <loader></loader>

    <no-habilitado v-if="!habilitado" perfil="Arkidians"></no-habilitado>
    <app-error v-if="error" :errorMensaje="errorMensaje"></app-error>

    <div v-if="habilitado" :style="estilos.categoriaStyle" id="categoria">
      <div
        class="mb-3 sombra"
        :style="estilos.categoriaStyleBar"
        style="text-align:center; margin-top:20px"
      >
        <div class="row no-gutters">
          <div class="col-md-12">
            <img
              :src="estilos.categoria.imagen"
              style="width:200px"
              class="card-img"
              alt="categoria"
            />
          </div>
          <div class="col-md-12">
            <div class="card-body">
              <h1 class="text-white">{{curso.nombre_curso}}</h1>
              <h3 class="text-white">{{curso.detalle_curso}}</h3>
            </div>
          </div>
        </div>
      </div>

      <section class="section-curso">
        <main>
          <div
            v-for="(contenido,index) in itemsCamino"
            :key="index"
            class="cont"
            :style="[contenido.styleObject]"
          >
            <div v-if="contenido.id_contenido" class="card" style="border:0px; border-radius: 15px">
              <img
                class="card-img contenido-image"
                :src="contenido.url_imagen"
                style="border-radius:10px;"
                alt="Card image"
              />
              <img
                v-on:click="verVideo(contenido)"
                v-if="contenido.porcentaje_avance!=100 && contenido.url_contenido != 'NULL' "
                style="cursor: pointer; position:absolute"
                class="card-img-dark"
                src="public/images/site/imagen-video-dark.svg"
                alt="Card image"
              />
              <img
                v-on:click="verVideo(contenido)"
                v-if="contenido.porcentaje_avance==100 && contenido.url_contenido != 'NULL' "
                style="cursor: pointer; position:absolute"
                class="card-img-dark"
                src="public/images/site/imagen-video-hecho.svg"
                alt="Card image"
              />
              <div class="card-body">
                <h4 class="titulo-video" :style="estilos.tituloStyle">{{contenido.nombre_contenido}}</h4>
                <h5
                  v-if="contenido.url_contenido != 'NULL'"
                  class="card-text"
                  :style="estilos.tituloStyle"
                >{{contenido.porcentaje_avance}}%</h5>

                <img
                  v-if="index%2 == 0"
                  :src="'public/images/site/contenido'+ index +'.svg'"
                  class="img-cont-izquierda"
                  alt="Arkidia"
                />
                <img
                  v-if="index%2 != 0"
                  :src="'public/images/site/contenido'+ index +'.svg'"
                  class="img-cont-derecha"
                  alt="Arkidia"
                />
              </div>
            </div>
            <div v-if="contenido.id_challenge" class="card" style="border:0px;border-radius: 15px;">
              <div
                v-if="(contenido.ind_completo == 0) ||(contenido.ind_aprobado == 'R') "
                class="image-upload"
              >
                <label :for="'file-input'+index" style="display:block;cursor:pointer">
                  <img src="public/images/site/imagen-challenge-dark.svg" alt="Card image" />
                </label>
                <input
                  type="file"
                  accept
                  @change="uploadImage($event,contenido)"
                  :id="'file-input'+index"
                />
              </div>

              <router-link
                v-if="contenido.ind_completo == 1 && contenido.ind_aprobado == 'N'"
                :to="'/Desafio/'+contenido.id_challenge+'/'+contenido.usuario"
                style="cursor:pointer"
                tag="div"
              >
                <img
                  v-if="contenido.ind_completo == 1 && contenido.ind_aprobado == 'N'"
                  class="card-img-dark"
                  src="public/images/site/pending.svg"
                  alt="Card image"
                />
                <img
                  class="card-img"
                  :src="contenido.url_contenido"
                  style="border-radius:15px;"
                  alt="Card image"
                />
              </router-link>

              <router-link
                v-if="contenido.ind_completo == 1 && contenido.ind_aprobado == 'S'"
                :to="'/Desafio/'+contenido.id_challenge+'/'+contenido.usuario"
                style="cursor:pointer"
              >
                <img
                  class="card-img"
                  :src="contenido.url_contenido"
                  style="border-radius:15px;cursor: pointer;"
                  alt="Card image"
                />
              </router-link>

              <img
                v-if="contenido.ind_aprobado == 'P'"
                class="card-img"
                src="public/images/site/loading.gif"
                style="border-radius:15px;"
                alt="loading"
              />

              <div class="card-body">
                <h4
                  v-if="contenido.ind_completo == 0"
                  class="subtitulo"
                  :style="estilos.tituloStyle"
                >{{contenido.detalle_challenge}}</h4>
                <h4
                  v-if="contenido.ind_completo == 1"
                  class="subtitulo"
                  :style="estilos.tituloStyle"
                >{{contenido.nombre_challenge}}</h4>

                <img
                  v-if="index%2 == 0"
                  :src="'public/images/site/contenido'+ index +'.svg'"
                  class="img-cont-izquierda"
                  alt="Arkidia"
                />
                <img
                  v-if="index%2 != 0"
                  :src="'public/images/site/contenido'+ index +'.svg'"
                  class="img-cont-derecha"
                  alt="Arkidia"
                />
              </div>
            </div>
          </div>
        </main>
      </section>
      <router-link
        v-if="$routerHistory.hasPrevious()"
        :to="{ path: $routerHistory.previous().path }"
        tag="button"
        class="btn boton-primario"
      >Volver</router-link>

      <section>
        <div
          class="mb-3 sombra"
          :style="estilos.categoriaStyleBar"
          style="text-align:center; margin-top:20px"
        >
          <div class="row no-gutters">
            <div class="col-md-12">
              <img
                src="public/images/site/comunity.svg"
                style="width:70%"
                class="card-img"
                alt="categoria"
              />
            </div>
            <div class="col-md-12">
              <div class="card-body">
                <h1 class="text-white">Mirá los desafíos de otros arkidians</h1>
              </div>
            </div>
          </div>
        </div>

        <div v-if="desafios.length==0">
          <h4 style="color:white">¡Subí el primer desafío para este curso!</h4>
          <img
            src="public/images/site/subir-challenge.svg"
            style="max-width:300px"
            id="challenges"
            alt="sin actividad"
          />
        </div>

        <div class="row" style="justify-content: center; display:block;width:100%">
          <div class="container">
            <div class="row" style="justify-content: center">
              <app-challenge
                v-for="(challenge,index) in desafios"
                :challenge="challenge"
                v-bind:key="index"
              ></app-challenge>
            </div>
          </div>
        </div>
      </section>
    </div>

    <b-modal
      size="xl"
      ref="video-modal"
      hide-footer
      :title="contenidoSeleccionado.nombre_contenido"
    >
      <div class="d-block text-center">
        <div style="text-align:center">
          <video-player
            class="vjs-custom-skin radio"
            ref="videoPlayer"
            :options="playerOptions"
            :playsinline="true"
            @play="onPlayerPlay($event)"
            @pause="onPlayerPause($event)"
            @ended="onPlayerEnded($event)"
            @loadeddata="onPlayerLoadeddata($event)"
            @waiting="onPlayerWaiting($event)"
            @playing="onPlayerPlaying($event)"
            @timeupdate="onPlayerTimeupdate($event)"
            @canplay="onPlayerCanplay($event)"
            @canplaythrough="onPlayerCanplaythrough($event)"
            @ready="playerReadied"
            @statechanged="playerStateChanged($event)"
          ></video-player>
        </div>
      </div>
    </b-modal>

    <b-modal ref="congrats" hide-footer title="¡Felicitaciones!">
      <div id="app" class="animation-logo">
        <lottie :options="defaultOptions" v-on:animCreated="handleAnimation" />
      </div>
      <div class="d-block text-center">
        <h5>¡Terminaste de ver la actividad!</h5>
        <p>Ganaste {{puntajeVideo}} puntos</p>
        <img src="public/images/site/winner.svg" style="width:200px" alt="categoria" />
      </div>
    </b-modal>

    <b-modal ref="error-modal" hide-footer title="Error">
      <div class="d-block text-center">
        <h5>Hubo un error al subir tu imagen.</h5>
        <p>Verificá que sea una imagen válida e intentá nuevamente</p>
        <hr>
        <p style="font-size:12px">Los formatos de imagen válidos son JPG, PNG y GIF</p>


        <b-button class="mt-2" variant="danger" block @click="cerrar()">Cerrar</b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Challenges from "../challenges/Challenge";
import Loader from "../shared/Loader";
import NoHabilitado from "../shared/NoHabilitado";
import appError from "../shared/Error";
import { videoPlayer } from "vue-video-player";
import "video.js/dist/video-js.css";
import Lottie from "vue-lottie";
import * as animationData from "../../assets/confeti.json";

export default {
  name: "app",
  data() {
    return {
      ancho: 1,
      videoFin: false,
      timeAvance: 0,
      contenidoSeleccionado: {
        nombre_contenido: ""
      },
      avanceContenido: 0,
      puntajeVideo: 0,
      playerOptions: {
        width: "300",
        autoplay: true,
        muted: false,
        fullscreen: true,
        language: "es",
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [
          {
            type: "video/mp4",
            src: ""
          }
        ],
        poster: ""
      },
      defaultOptions: {
        animationData: animationData,

        loop: true
      },
      animationSpeed: 1,
      width: "600",

      errorMensaje: "",
      habilitado: false,
      error: false,
      curso: "",
      desafios: "",
      hayFelicitacion: false,
      itemsCamino: [],
      estilos: {
        categoriaStyleBar: "",
        categoriaStyle: "",
        categoria: ""
      }
    };
  },
  props: ["id"],
  methods: {
    buscarInscripcion(curso, usuario) {
      fetch(
        this.pathAPI +
          "inscripcion.php?usuario=" +
          usuario +
          "&id_curso=" +
          curso
      )
        .then(response => response.json())
        .then(data => {
          if (data.resultado == "ERROR") {
            this.error = true;
          } else {
            for (var i = 0; i < this.categorias.length; i++) {
              if (this.categorias[i].id == data.id_categoria) {
                this.estilos.categoriaStyleBar =
                  "background-color: #" + this.categorias[i].color + "aa";
                this.estilos.categoriaStyle =
                  "background-color: #" + this.categorias[i].color;
                this.estilos.tituloStyle = "color:#" + this.categorias[i].color;
                this.estilos.categoria = this.categorias[i];
              }
            }
            const loader = document.querySelector(".loader");
            loader.className += " hidden";
          }

          this.itemsCamino = [];
          this.curso = data;
          console.log(data);
          this.formatoContenido();
          this.formatoChallenge(usuario, curso);
          this.itemsCamino = this.curso.contenido.concat(this.curso.challenge);
        });
    },
    buscarDesafios() {
      fetch(
        this.pathAPI +
          "challenge_alumno.php?id_curso=" +
          this.id +
          "&usuario=" +
          this.userLogged.user
      )
        .then(response => response.json())
        .then(data => {
          this.desafios = data;
        });
    },
    buscarPuntaje() {
      console.log("buscarPuntaje");
      fetch(this.pathAPI + "puntaje.php?usuario=" + this.userLogged.user)
        .then(response => response.json())
        .then(data => {
          console.log(data);
          if (data) {
            for (var i = 0; i < data.length; i++) {
              if (data[i].evento == "video") {
                this.puntajeVideo = data[i].puntaje;
              }
            }
          }
        });
    },
    formatoContenido() {
      if (this.curso.contenido) {
        for (var i = 0; i < this.curso.contenido.length; i++) {
          if (this.curso.contenido[i].porcentaje_avance == 100) {
            this.curso.contenido[i].styleObject = { color: "#ffffff" };
          }
          this.curso.contenido[i].styleObject = { color: "#ffffff66" };
        }
      }
    },

    formatoChallenge(usuario, curso) {
      if (this.curso.challenge) {
        for (var i = 0; i < this.curso.challenge.length; i++) {
          this.curso.challenge[i].usuario = usuario;
          this.curso.challenge[i].id_curso = curso;
          if (this.curso.challenge[i].ind_completo == 1) {
            this.curso.challenge[i].styleObject = { color: "#ffffff" };
          } else {
            this.curso.challenge[i].styleObject = { color: "#ffffff66" };
          }
        }
      }
    },

    playPause() {
      var myVideo = document.getElementById("video1");
      if (myVideo.paused) myVideo.play();
      else myVideo.pause();
    },

    verChallenge(contenido) {
      sessionStorage.usuarioChallenge = contenido.usuario;
      sessionStorage.idChallenge = contenido.id_challenge;
      sessionStorage.cursoChallenge = contenido.id_curso;
      this.$store.state.challengeSeleccionado = contenido;
      this.$router.push({ path: "/Desafio" });
    },

    inscribirCurso(curso) {
      var self = this;
      var bodyApi;
      bodyApi = "usuario=" + self.userLogged.user + "&id_curso=" + curso;
      fetch(self.pathAPI + "inscripcion.php", {
        method: "POST",
        body: bodyApi,
        headers: new Headers({
          "Content-Type": "application/x-www-form-urlencoded"
        })
      }).then(function(response) {
        if (response.ok) {
          var loginResponse;
          loginResponse = response.json();
          loginResponse.then(function(result) {
            if (result.resultado == "ERROR") {
              self.errorMensaje = result.mensaje;
              self.error = true;
              const loader = document.querySelector(".loader");
              loader.className += " hidden";
            } else {
              self.buscarInscripcion(curso, self.userLogged.user);
              if (!self.error) self.buscarDesafios();
            }
          });
        } else {
          throw "Error en la llamada Ajax";
        }
      });
    },

    previsualizarCurso(curso) {
      var self = this;
      fetch(
        this.pathAPI +
          "inscripcion.php?usuario=" +
          this.userLogged.user +
          "&id_curso=" +
          curso,
        {
          method: "DELETE"
        }
      ).then(() => {
        var bodyApi;
        bodyApi = "usuario=" + this.userLogged.user + "&id_curso=" + curso;
        fetch(this.pathAPI + "inscripcion.php", {
          method: "POST",
          body: bodyApi,
          headers: new Headers({
            "Content-Type": "application/x-www-form-urlencoded"
          })
        }).then(function(response) {
          if (response.ok) {
            var loginResponse;
            loginResponse = response.json();
            loginResponse.then(function(result) {
              if (result.resultado == "ERROR") {
                self.errorMensaje = result.mensaje;
                self.error = true;
                const loader = document.querySelector(".loader");
                loader.className += " hidden";
              } else {
                self.buscarInscripcion(curso, self.userLogged.user);
                if (!self.error) self.buscarDesafios();
              }
            });
          } else {
            throw "Error en la llamada Ajax";
          }
        });
      });
    },

    uploadImage(event, contenido) {
      var self = this;
      const formData = new FormData();

      var formato = event.target.files[0].type;

      if (formato.substring(0, 5) != "image") {
        contenido.ind_completo = 0;
        contenido.ind_aprobado = "N";
        self.$refs["error-modal"].show();
        return;
      }

      console.log();
      console.log(contenido);

      formData.append("imagen", event.target.files[0]);

      const options = {
        method: "POST",
        body: formData
      };
      contenido.ind_completo = 1;
      contenido.ind_aprobado = "P";

      fetch(this.pathAPI + "imagen.php", options)
        .then(function(res) {
          if (!res.ok) {
            contenido.ind_completo = 0;
            contenido.ind_aprobado = "N";
            self.$refs["error-modal"].show();
          }
          return res.json();
        })
        .then(function(data) {
          if (data) {
            if (data.resultado == "ERROR") {
              contenido.ind_completo = 0;
              contenido.ind_aprobado = "N";
              self.$refs["error-modal"].show();
              return;
            }
            console.log(data);
            contenido.url_contenido = data.url;
            contenido.ind_aprobado = "N";
            var bodyApi;
            (bodyApi =
              "imagen=" +
              data.url +
              "&id_curso=" +
              self.id +
              "&id_challenge=" +
              contenido.id_challenge +
              "&usuario_challenge=" +
              self.userLogged.user),
              fetch(self.pathAPI + "challenge_alumno.php", {
                method: "POST",
                body: bodyApi,
                headers: new Headers({
                  "Content-Type": "application/x-www-form-urlencoded"
                })
              }).then(function(response) {
                console.log(response);
                if (response.ok) {
                  var loginResponse;
                  loginResponse = response.json();
                  loginResponse.then(function(result) {
                    if (result.resultado === "ERROR") {
                      console.log("ERROR");
                    } else {
                      console.log("actualización de imagen");
                    }
                  });
                } else {
                  throw "Error en la llamada Ajax";
                }
              });
          }
        });
    },
    cerrar() {
      this.$refs["error-modal"].hide();
    },

    verVideo(contenido) {
      this.contenidoSeleccionado = contenido;
      if (innerWidth < 576) {
        this.playerOptions.width = innerWidth - 50;
        this.playerOptions.height = innerHeight - 200;
      } else if (innerWidth < 992) {
        this.playerOptions.width = 460;
        this.playerOptions.height = innerHeight - 200;
      } else if (innerWidth < 1200) {
        this.playerOptions.width = 760;
        this.playerOptions.height = innerHeight - 200;
      } else {
        this.playerOptions.width = 1106 - 20;
        this.playerOptions.height = innerHeight - 200;
      }

      this.playerOptions.poster = contenido.url_imagen;
      this.playerOptions.sources[0].src = contenido.url_contenido;
      if (contenido.porcentaje_avance < 100) {
        this.avanceContenido = contenido.porcentaje_avance;
        this.hayFelicitacion = true;
      } else {
        this.avanceContenido = 0;
        this.hayFelicitacion = false;
      }
      this.$refs["video-modal"].show();
    },
    onPlayerPlay(player) {
      // console.log("player play!", player);
      if (this.avanceContenido) {
        player.currentTime((this.avanceContenido * player.duration()) / 100);
        this.avanceContenido = null;
      }
      this.timeAvance = player.currentTime();
    },

    onPlayerPause(player) {
      //console.log("player pause!", player);
    },
    onPlayerEnded(player) {
      var self = this;

      if (this.hayFelicitacion) {
        this.$refs["congrats"].show();
        this.$refs["video-modal"].hide();
      }
    },
    onPlayerLoadeddata(player) {
      //console.log("player Loadeddata!", player);
    },
    onPlayerWaiting(player) {
      //console.log("player Waiting!", player);
    },
    onPlayerPlaying(player) {
      //console.log("player Playing!", player);
    },
    onPlayerTimeupdate(player) {
      var self = this;

      if (player.currentTime() > self.timeAvance) {
        var avance = (player.currentTime() / player.duration()) * 100;

        if (avance > 97) {
          avance = 100;
        }
        if (
          avance > self.contenidoSeleccionado.porcentaje_avance &&
          self.contenidoSeleccionado.porcentaje_avance != 100
        ) {
          var bodyApi =
            "id_contenido=" +
            self.contenidoSeleccionado.id_contenido +
            "&usuario=" +
            self.userLogged.user +
            "&porcentaje_avance=" +
            avance;
          fetch(this.pathAPI + "contenido_alumno.php?" + bodyApi, {
            method: "PUT",
            body: bodyApi,
            headers: new Headers({
              "Content-Type": "application/x-www-form-urlencoded"
            })
          }).then(function(response) {
            if (response.ok) {
              self.contenidoSeleccionado.porcentaje_avance = Math.floor(avance);
            } else {
              throw "Error en la llamada Ajax";
            }
          });
        }

        this.timeAvance += 5;
      }
    },
    onPlayerCanplay(player) {
      // console.log('player Canplay!', player)
    },
    onPlayerCanplaythrough(player) {
      // console.log('player Canplaythrough!', player)
    },
    // or listen state event
    playerStateChanged(playerCurrentState) {
      //  console.log('player current update state', playerCurrentState)
    },
    // player is ready
    playerReadied(player) {
      // seek to 10s
      //console.log("example player 1 readied", player);
      //player.currentTime(10);
      // console.log('example 01: the player is readied', player)
    },
    handleAnimation: function(anim) {
      this.anim = anim;
    },

    stop: function() {
      this.anim.stop();
    },

    play: function() {
      this.anim.play();
    },

    pause: function() {
      this.anim.pause();
    },

    onSpeedChange: function() {
      this.anim.setSpeed(this.animationSpeed);
    }
  },
  computed: {
    ...mapGetters(["pathAPI", "userLogged", "categorias"])
  },
  components: {
    appChallenge: Challenges,
    Loader: Loader,
    NoHabilitado: NoHabilitado,
    appError: appError,
    videoPlayer,
    lottie: Lottie
  },
  watch: {
    $route(to, from) {
      this.error = false;
      if (this.userLogged.profile == "HIJO") {
        this.habilitado = true;
        this.inscribirCurso(this.id);
        if (!this.error) this.buscarDesafios();
      }
      if (this.userLogged.profile == "ADMINISTRADOR") {
        this.habilitado = true;
        this.previsualizarCurso(this.id);
      }
    }
  },
  mounted: function() {
    this.ancho = innerWidth;
    if (this.userLogged.profile == "HIJO") {
      this.habilitado = true;
      this.inscribirCurso(this.id);
      if (!this.error) this.buscarDesafios();
      this.buscarPuntaje();
    }
    if (this.userLogged.profile == "ADMINISTRADOR") {
      this.habilitado = true;
      this.previsualizarCurso(this.id);
      this.buscarPuntaje();
    }
  }
};
</script>


<style scoped>
.img-cont-izquierda {
  width: 100px;
  float: left;
  margin-left: -40px;
  margin-bottom: -40px;
  margin-top: -100px;
}
.img-cont-derecha {
  width: 100px;
  float: right;
  margin-right: -40px;
  margin-bottom: -40px;
  margin-top: -100px;
}

#categoria {
  background-image: url(/public/images/site/categoria.svg);
  background-repeat: no-repeat;
  padding-top: 100px;
  background-size: 100%;
  text-align: -webkit-center;
  display: table;
  position: relative;
  width: 100%;
}
.section-curso {
  padding: 40px 8%;
}
.sombra {
  box-shadow: -1px 11px 16px 1px rgba(0, 0, 0, 0.32);
}
.cont {
  font-family: "Raleway", sans-serif;
  text-align: -webkit-center;
  font-size: 25px;
  line-height: 25px;
  border-top: 10px solid;
  z-index: 1;
  border-image-slice: 1;
  border-width: 20px;
  margin: 0;
  padding: 10px;
  position: relative;
  counter-increment: section;
  min-height: 200px;
}
.cont:before {
  margin-top: 100px;
  font-family: "Patua One", cursive;
  content: counter(section);
  line-height: 110px;
  position: absolute;
  border-radius: 10px;
  height: 120px;
  width: 80px;
  text-align: center;
  color: #777777;
  font-size: 100px;
  z-index: 1;
  background-color: white;
}
.cont:nth-child(even) {
  border-right: 20px solid;
  padding: 20px;
  border-radius: 0 0px 0px 0;
  margin-left: 0px;
  margin-top: 0px;
}
.cont:nth-child(even):before {
  left: 100%;
  top: 0%;
}
.cont:nth-child(odd) {
  border-left: 20px solid;
  padding: 20px;
  border-radius: 0px 0 0px 0px;
  margin-top: 0px;
  margin-right: 0px;
}
.cont:nth-child(odd):before {
  right: 100%;
  top: 0%;
}
.cont:first-child {
  border-top: 0;
  stroke-linecap: round;
  border-radius: 15 15px;
}
.cont:last-child {
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
}

.image-upload > input {
  visibility: hidden;
  width: 0;
  height: 0;
}

main {
  max-width: 500px;
  margin: auto;
  padding-top: 10px;
}
.card-img-dark {
  position: absolute;
}

@media screen and (max-width: 600px) {
  .img-cont-izquierda {
    width: 40px;
    float: left;
    margin-left: -40px;
    margin-bottom: -40px;
    margin-top: -40px;
  }
  .img-cont-derecha {
    width: 40px;
    float: right;
    margin-right: -40px;
    margin-bottom: -40px;
    margin-top: -40px;
  }

  main {
    max-width: 250px;
    margin: auto;
    padding-top: 10px;
  }
  .cont {
    font-family: "Raleway", sans-serif;
    text-align: -webkit-center;
    font-size: 25px;
    line-height: 25px;
    border-top: 10px solid;
    z-index: 1;
    border-image-slice: 1;
    border-width: 20px;
    margin: 0;
    padding: 10px;
    position: relative;
    counter-increment: section;
    min-height: 200px;
  }
  .cont:before {
    margin-top: 50px;
    font-family: "Patua One", cursive;
    content: counter(section);
    line-height: 60px;
    position: absolute;
    border-radius: 00px;
    height: 60px;
    width: 50px;
    text-align: center;
    color: #777777;
    font-size: 50px;
    z-index: 1;
    background-color: white;
  }
  .cont:nth-child(even) {
    border-right: 20px solid;
    padding: 10px;
    border-radius: 0 0px 0px 0;
    margin-left: 0px;
    margin-top: 0px;
  }
  .cont:nth-child(even):before {
    left: 100%;
    top: 0%;
  }
  .cont:nth-child(odd) {
    border-left: 20px solid;
    padding: 10px;
    border-radius: 0px 0 0px 0px;
    margin-top: 0px;
    margin-right: 0px;
  }
  .cont:nth-child(odd):before {
    right: 100%;
    top: 0%;
  }
  .cont:first-child {
    border-top: 0;
    stroke-linecap: round;
    border-radius: 15 15px;
  }
  .cont:last-child {
    border-bottom-right-radius: 0px;
    border-bottom-left-radius: 0px;
  }
  .section-curso {
    padding: 10px 2%;
  }
}

.vjs-custom-skin > .video-js {
  width: 100%;
  border-radius: 15px;
  font-family: "PingFang SC", "Helvetica Neue", "Hiragino Sans GB", "Segoe UI",
    "Microsoft YaHei", "微软雅黑", sans-serif;
}

.vjs-custom-skin > .video-js .vjs-menu-button-inline.vjs-slider-active,
.vjs-custom-skin > .video-js .vjs-menu-button-inline:focus,
.vjs-custom-skin > .video-js .vjs-menu-button-inline:hover,
.video-js.vjs-no-flex .vjs-menu-button-inline {
  width: 10em;
}

.vjs-custom-skin > .video-js .vjs-controls-disabled .vjs-big-play-button {
  display: none !important;
}

.vjs-custom-skin > .video-js .vjs-control {
  width: 3em;
}

.vjs-custom-skin > .video-js .vjs-control.vjs-live-control {
  width: auto;
  padding-left: 0.5em;
  letter-spacing: 0.1em;
}

.vjs-custom-skin > .video-js .vjs-menu-button-inline:before {
  width: 1.5em;
}

.vjs-menu-button-inline .vjs-menu {
  left: 3em;
}

.vjs-paused.vjs-has-started.vjs-custom-skin > .video-js .vjs-big-play-button,
.video-js.vjs-ended .vjs-big-play-button,
.video-js.vjs-paused .vjs-big-play-button {
  display: block;
}

.vjs-custom-skin > .video-js .vjs-load-progress div,
.vjs-seeking .vjs-big-play-button,
.vjs-waiting .vjs-big-play-button {
  display: none !important;
}

.vjs-custom-skin > .video-js .vjs-mouse-display:after,
.vjs-custom-skin > .video-js .vjs-play-progress:after {
  padding: 0 0.4em 0.3em;
}

.video-js.vjs-ended .vjs-loading-spinner {
  display: none;
}

.video-js.vjs-ended .vjs-big-play-button {
  display: block !important;
}

.video-js.vjs-ended .vjs-big-play-button,
.video-js.vjs-paused .vjs-big-play-button,
.vjs-paused.vjs-has-started.vjs-custom-skin > .video-js .vjs-big-play-button {
  display: block;
}

.vjs-custom-skin > .video-js .vjs-big-play-button {
  top: 50%;
  left: 50%;
  margin-left: -1.5em;
  margin-top: -1em;
  border-radius: 15px;
}

.vjs-custom-skin > .video-js .vjs-big-play-button {
  background-color: rgba(0, 0, 0, 0.45);
  font-size: 3.5em;
  /*border-radius: 50%;*/
  height: 2em !important;
  line-height: 2em !important;
  margin-top: -1em !important;
}

.video-js:hover .vjs-big-play-button,
.vjs-custom-skin > .video-js .vjs-big-play-button:focus,
.vjs-custom-skin > .video-js .vjs-big-play-button:active {
  background-color: rgba(36, 131, 213, 0.9);
}

.vjs-custom-skin > .video-js .vjs-loading-spinner {
  border-color: rgba(36, 131, 213, 0.8);
}

.vjs-custom-skin > .video-js .vjs-control-bar2 {
  background-color: #000000;
}

.vjs-custom-skin > .video-js .vjs-control-bar {
  /*background-color: rgba(0,0,0,0.3) !important;*/
  color: #ffffff;
  font-size: 14px;
}

.vjs-custom-skin > .video-js .vjs-play-progress,
.vjs-custom-skin > .video-js .vjs-volume-level {
  background-color: #2483d5;
}

.vjs-custom-skin > .video-js .vjs-play-progress:before {
  top: -0.3em;
}

.vjs-custom-skin > .video-js .vjs-progress-control:hover .vjs-progress-holder {
  font-size: 1.3em;
}

.vjs-menu-button-popup.vjs-volume-menu-button-vertical .vjs-menu {
  left: 0em;
}

.vjs-custom-skin > .video-js .vjs-menu li {
  padding: 0;
  line-height: 2em;
  font-size: 1.1em;
  font-family: "PingFang SC", "Helvetica Neue", "Hiragino Sans GB", "Segoe UI",
    "Microsoft YaHei", "微软雅黑", sans-serif;
}

.vjs-custom-skin > .video-js .vjs-time-tooltip,
.vjs-custom-skin > .video-js .vjs-mouse-display:after,
.vjs-custom-skin > .video-js .vjs-play-progress:after {
  border-radius: 0;
  font-size: 1em;
  padding: 0;
  width: 3em;
  height: 1.5em;
  line-height: 1.5em;
  top: -3em;
}

.vjs-custom-skin > .video-js .vjs-menu-button-popup .vjs-menu {
  width: 5em;
  left: -1em;
}

.vjs-custom-skin
  > .video-js
  .vjs-menu-button-popup.vjs-volume-menu-button-vertical
  .vjs-menu {
  left: 0;
}

.vjs-custom-skin > .video-js .vjs-control-bar .vjs-play-control {
  order: 0;
}

.vjs-custom-skin > .video-js .vjs-control-bar .vjs-time-control {
  min-width: 1em;
  padding: 0;
  margin: 0 0.1em;
  text-align: center;
  display: block;
  order: 1;
}

.vjs-custom-skin
  > .video-js
  .vjs-control-bar
  .vjs-playback-rate
  .vjs-playback-rate-value {
  font-size: 1.2em;
  line-height: 2.4;
}

.vjs-custom-skin > .video-js .vjs-progress-control.vjs-control {
  order: 2;
}

.vjs-custom-skin > .video-js .vjs-control-bar .vjs-volume-menu-button {
  order: 3;
}

.vjs-custom-skin > .video-js .vjs-control-bar .vjs-resolution-button {
  order: 4;
}

.vjs-custom-skin
  > .video-js
  .vjs-control-bar
  .vjs-resolution-button
  .vjs-resolution-button-label {
  display: block;
  line-height: 3em;
}

.vjs-custom-skin > .video-js .vjs-control-bar .vjs-playback-rate {
  order: 5;
}

.vjs-custom-skin > .video-js .vjs-control-bar .vjs-fullscreen-control {
  order: 6;
}

.video-js {
  border-radius: 15px !important;
}

.animation-logo {
  width: 100%;
  margin-left: -25%;
  position: fixed;
  z-index: 100;
}

.modal-dialog {
  max-width: 100% !important;
  margin: 10px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/sections/Activity.vue